var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-page",
    {
      attrs: {
        "view-slug": `${
          _vm.isReleased()
            ? "icon-pack-landing"
            : "icon-pack-landing icon-pack-landing-prerelease"
        } icon-pack-landing-${_vm.iconPack()?.name}`,
        "custom-style": _vm.viewStyle,
      },
    },
    [
      _c("wa-page-header", {
        key: "header",
        attrs: {
          slot: "header",
          "theme-color": "var(--theme-action-primary)",
          "is-inverted": "",
        },
        slot: "header",
      }),
      _vm._v(" "),
      _c(
        "main",
        {
          staticClass: "app-content padding-bottom-7xl",
          attrs: { slot: "content", role: "main" },
          slot: "content",
        },
        [
          _vm.isLoading()
            ? _c("wa-icons-loading")
            : [
                _c("pack-hero"),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    staticClass: "padding-top-5xl padding-bottom-2xl",
                    attrs: { id: "about-pack" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "container" },
                      [
                        _c("div", { staticClass: "row align-stretch" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "display-none tablet:display-block tablet:column-6 tablet:padding-right-2xl laptop:column-4",
                            },
                            [
                              _c("pack-icon-design-showcase", {
                                attrs: {
                                  "is-highlighting-icon-design-canvas":
                                    _vm.isHighlightingIconDesignCanvas,
                                  "is-highlighting-icon-design-grid":
                                    _vm.isHighlightingIconDesignGrid,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "order-first column-12 tablet:column-6 laptop:column-7 laptop:margin-bottom-0 laptop:offset-1",
                            },
                            [_c("pack-about")],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("pack-actions", {
                          key: "pack-actions",
                          attrs: { "is-for-smaller-viewports": true },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "margin-top-3xl" },
                          [
                            _c("pack-specs", {
                              on: { toggleIconDesign: _vm.toggleIconDesign },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.isReleased() ? _c("pack-playground") : _vm._e(),
                _vm._v(" "),
                _c("pack-mockups"),
                _vm._v(" "),
                _vm.isReleased() ? _c("pack-icons") : _vm._e(),
                _vm._v(" "),
                _c("pack-related"),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c("wa-page-footer", { attrs: { slot: "footer" }, slot: "footer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }